<template>
  <q-card flat>
    <q-card-section class="no-padding q-mb-xs">
      <q-select
          filled
          v-if="!durationState"
          :options="targetList"
          option-label="Title"
          option-value="id"
          v-model="selectedTarget"
          label="جهت گزارش هدف سازمانی را انتخاب کنید"
      />
      <SelectDateRange v-if="durationState" @show-comments="loadCommentsDuration"/>
    </q-card-section>
    <q-card-actions align="center" class="q-gutter-sm">
      <q-btn color="indigo" label="عملکرد" icon="visibility"
             v-if="selectedTarget"
             @click="$emit('target-selected', {startDate: selectedTarget.AuditStartDate,endDate: selectedTarget.AuditEndDate, targetId: selectedTarget.id, salePrice:selectedTarget.salePrice})"/>

      <q-btn color="indigo" label="چاپ گزارش ماهانه مدیر فروش" icon="visibility"
             v-if="selectedTarget && $store.state.roles.some(v=>['admin','salemanager'].includes(v))"
             @click="loadSaleManagerReport"/>

      <q-btn color="indigo" label="گزارشات" icon="receipt_long"
             v-if="selectedTarget"
             @click="$emit('show-comments', {startDate: selectedTarget.AuditStartDate,endDate: selectedTarget.AuditEndDate, targetId: selectedTarget.id, salePrice:selectedTarget.salePrice})"/>

      <q-btn color="indigo" label="داشبورد گروه کالایی" icon="pie_chart"
             v-if="selectedTarget && $store.state.roles.some(v=>['admin','salemanager'].includes(v))"
             @click="$emit('show-goods-group-dashboard', {startDate: selectedTarget.AuditStartDate,endDate: selectedTarget.AuditEndDate, salePrice:selectedTarget.salePrice})"/>
    </q-card-actions>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import SelectDateRange from "@/components/dashboard/SelectDateRange.vue";

export default {
  name: "SelectMasterTarget",
  components: {SelectDateRange},
  props: {
    durationState: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data() {
    return {
      targetList: [],
      selectedTarget: undefined
    }
  },
  methods: {
    ...mapActions({
      setTargetsList: 'Targets/getMasterTargets'
    }),
    loadCommentsDuration(args) {
      this.$emit('show-comments', {
        startDate: args.startDate,
        endDate: args.endDate,
        targetId: undefined,
        salePrice: undefined
      })
    },
    getMasterTargets() {
      this.setTargetsList().then((res) => {
        this.targetList = res
      })
    },
    async loadSaleManagerReport() {
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مدیر فروش/داشبورد وضعیت ماه?rs:Format=PDF&StartDate=${this.selectedTarget.AuditStartDate}&EndDate=${this.selectedTarget.AuditEndDate}&rc:Parameters=False&rc:Zoom=Page Width`)
    }
  },
  created() {
    this.getMasterTargets();
  }
}
</script>

<style scoped>

</style>